var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/connection/Partner/PartnerConnection/CommercialApi/index.tsx";
import React, { useMemo, useState } from 'react';
import { Divider, HStack, IconInfo, LoadingSpinner, Stack, Text } from '@adc/parallax-component-library';
import { useApiError, useLibrePartner, useToast } from 'Hooks';
import { InfoModal, Link, RichText } from 'Components/utility';
import { formatTimestamp } from 'Utilities/dateHelpers';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
import HealthDataCommercialApi from './HealthDataCommercialApi';
const CommercialApi = ({
  partnerConnection
}) => {
  const [showModalInfo, setShowModalInfo] = useState(false);
  const [footerLoading, setFooterLoading] = useState(false);
  const {
    showApiErrorModal
  } = useApiError();
  const {
    showToast
  } = useToast();
  const {
    removePartner,
    showStopSharingModal
  } = useLibrePartner();
  const {
    time,
    monthDate
  } = formatTimestamp(partnerConnection.consent.created, i18n.language, 'MMM d, yyyy');
  const scopes = useMemo(() => [...new Set(partnerConnection.consent.scopes.reduce((acc, scope) => {
    const splittedScope = scope.split('.');
    if (splittedScope.length > 1) {
      acc.push(splittedScope[1]);
    }
    return acc;
  }, []))], [partnerConnection.consent.scopes]);
  const scopesStr = useMemo(() => {
    const scopeStrArr = scopes.map(key => i18n.t(`Global.microcopy.scopes.${key}`).toLowerCase());
    scopeStrArr[0] = scopeStrArr[0].split('')[0].toUpperCase() + scopeStrArr[0].slice(1);
    return scopeStrArr.join(', ');
  }, [scopes]);
  const scopesModal = useMemo(() => {
    return /*#__PURE__*/React.createElement(Stack, {
      gap: "$4",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 69,
        columnNumber: 7
      }
    }, scopes.map(scope => {
      let bodyKey = `Connections.modals.dataSharingBottomSheet.${scope}`;
      if (scope === 'glucose') {
        const currentGlucose = partnerConnection.consent.currentGlucose;
        if (currentGlucose) {
          bodyKey = `Connections.modals.dataSharingBottomSheet.${scope}_cg`;
        }
      }
      return /*#__PURE__*/React.createElement(Stack, {
        key: scope,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 82,
          columnNumber: 13
        }
      }, /*#__PURE__*/React.createElement(Text, {
        testID: `ConnectedCommercialApi.scope.${scope}`,
        marginBottom: "$2",
        color: "$text.100",
        fontWeight: "$bodyBase.strong",
        fontSize: "$bodyBase.strong",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 83,
          columnNumber: 15
        }
      }, `${i18n.t(`Connections.modals.dataSharingBottomSheet.${scope}Title`)}`), /*#__PURE__*/React.createElement(Stack, {
        marginLeft: "$3",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 92,
          columnNumber: 15
        }
      }, /*#__PURE__*/React.createElement(RichText, {
        fontToken: "$bodySmall.default",
        testID: `ConnectedCommercialApi.scope.${scope}.description`,
        text: i18n.t(bodyKey),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 93,
          columnNumber: 17
        }
      })));
    }));
  }, [partnerConnection.consent.currentGlucose, scopes]);
  const onStopSharing = () => {
    showStopSharingModal(partnerConnection.partner.name, 'Global.modals.stopSharingPartner.title', 'Global.modals.stopSharingPartner.body', async () => {
      try {
        setFooterLoading(true);
        await removePartner(partnerConnection.partner.id);
        showToast({
          message: i18n.t('Global.modals.removeConnection.connectionRemoved'),
          'aria-label': i18n.t('Global.modals.removeConnection.connectionRemoved')
        });
        mediator.publish('router:navigate', '/connections');
      } catch {
        showApiErrorModal();
      } finally {
        setFooterLoading(false);
      }
    });
  };
  if (partnerConnection.consent.scopes.includes('read.healthData')) {
    return /*#__PURE__*/React.createElement(HealthDataCommercialApi, {
      partnerConnection: partnerConnection,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 132,
        columnNumber: 12
      }
    });
  }
  return /*#__PURE__*/React.createElement(Stack, {
    margin: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 136,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    padding: "$4",
    backgroundColor: "$surface.container",
    border: "$1.5",
    shadow: "$1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 137,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "ConnectedCommercialApi.title",
    color: "$text.100",
    fontWeight: "$h4.strong",
    fontSize: "$h4.strong",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 138,
      columnNumber: 9
    }
  }, i18n.t('ConnectedCommercialApi.content.connectedOAuthPartnerTile.primaryText')), /*#__PURE__*/React.createElement(Text, {
    testID: "ConnectedCommercialApi.bodyText",
    marginTop: "$2",
    color: "$text.100",
    fontWeight: "$bodyBase.default",
    fontSize: "$bodyBase.default",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 146,
      columnNumber: 9
    }
  }, i18n.t('ConnectedCommercialApi.content.connectedOAuthPartnerTile.secondaryText', {
    partnerName: partnerConnection.partner.name
  })), /*#__PURE__*/React.createElement(HStack, {
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginTop: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 157,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "ConnectedCommercialApi.scopes",
    color: "$text.100",
    fontWeight: "$bodyBase.medium",
    fontSize: "$bodyBase.medium",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 158,
      columnNumber: 11
    }
  }, scopesStr), /*#__PURE__*/React.createElement(Stack, {
    onPress: () => setShowModalInfo(true),
    cursor: "pointer",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 166,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(IconInfo, {
    testID: "ConnectedCommercialApi.info-icon",
    size: "S",
    color: "$interactive.core.enabled",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 167,
      columnNumber: 13
    }
  }))), /*#__PURE__*/React.createElement(Text, {
    testID: "ConnectedCommercialApi.connectedAt",
    marginTop: "$4",
    color: "$text.60",
    fontWeight: "$bodySmall.default",
    fontSize: "$bodySmall.default",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 174,
      columnNumber: 9
    }
  }, i18n.t('Global.microcopy.common.connectedOnDateTime', {
    time,
    monthDate
  })), /*#__PURE__*/React.createElement(Divider, {
    marginVertical: "$4",
    borderColor: "$neutral.40",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 186,
      columnNumber: 9
    }
  }), footerLoading ? /*#__PURE__*/React.createElement(Stack, {
    width: "100%",
    display: "flex",
    alignItems: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 188,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(LoadingSpinner, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 189,
      columnNumber: 13
    }
  })) : /*#__PURE__*/React.createElement(Link, {
    testID: "ConnectedCommercialApi.stopSharing-btn",
    onPress: onStopSharing,
    linkTextColor: "$support.danger.default",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 192,
      columnNumber: 11
    }
  }, i18n.t('Global.modals.stopSharing.title')), /*#__PURE__*/React.createElement(InfoModal, {
    isOpen: showModalInfo,
    title: i18n.t('Connections.modals.dataSharingBottomSheet.title'),
    customBody: scopesModal,
    handleClose: () => setShowModalInfo(false),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 200,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(Text, {
    testID: "ConnectedCommercialApi.subtitle",
    marginTop: "$4",
    color: "$text.60",
    fontWeight: "$bodySmall.default",
    fontSize: "$bodySmall.default",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 207,
      columnNumber: 7
    }
  }, i18n.t('ConnectedCommercialApi.subtitle')));
};
export default CommercialApi;